import React, { useState, useRef, useEffect } from "react";
import { BlueLogo } from "../../shared/functional/global-image-import";
import { Button, Image, Icon } from "semantic-ui-react";



const ScreenSizePopup = (prop) => {
       

    return (
        <div className="login">

            <div className="loginInner">
                
                <div className='loginInnerBox'>
                    <Image className='logo' src={BlueLogo} />

                    <h4 className="ui header">Please resize your window</h4>
                    <p>
                        ALEE is not optimized for mobile devices, small tablets or small browser windows.
                        Please log in using a desktop or laptop device or increase your browser window size.
                    </p>

                    <Button className="primaryBtn" onClick={prop.onClose}>Close</Button>
                </div>
            </div>
        </div>
    )
}

export default ScreenSizePopup